import * as React from 'react';
import classNames from 'classnames';
import BigCornerBulgeShape from '../../icons/shapes/BigCornerBulgeShape.esm.js';
import BottomBigWaveShape from '../../icons/shapes/BottomBigWaveShape.esm.js';
import BottomSmallWaveShape from '../../icons/shapes/BottomSmallWaveShape.esm.js';
import CropCornerShape from '../../icons/shapes/CropCornerShape.esm.js';
import CropSideShape from '../../icons/shapes/CropSideShape.esm.js';
import CurvedCornerBulgeShape from '../../icons/shapes/CurvedCornerBulgeShape.esm.js';
import CurvedCropCornerShape from '../../icons/shapes/CurvedCropCornerShape.esm.js';
import MediumBubbleShape from '../../icons/shapes/MediumBubbleShape.esm.js';
import SmallBubbleShape from '../../icons/shapes/SmallBubbleShape.esm.js';
import SmallCornerBulgeShape from '../../icons/shapes/SmallCornerBulgeShape.esm.js';
import styles from './ShapeComponent.module.esm.js';

var ShapeComponent = function (_a) {
    var _b = _a.fields, shapePosition = _b.shapePosition, shapeType = _b.shapeType, shapeColor = _b.shapeColor, id = _a.id;
    var colorClassName = "shape-".concat(shapeColor);
    var positionClassName = "shape-".concat(shapePosition);
    var shapeClassName = "shape-".concat(shapeType);
    var getShape = function () {
        switch (shapeType) {
            case 'curvedCropCorner': {
                return React.createElement(CurvedCropCornerShape, { className: styles[colorClassName] });
            }
            case 'cropSide': {
                return React.createElement(CropSideShape, { className: styles[colorClassName] });
            }
            case 'cropCorner': {
                return React.createElement(CropCornerShape, { className: styles[colorClassName] });
            }
            case 'smallBubble': {
                return React.createElement(SmallBubbleShape, { className: styles[colorClassName] });
            }
            case 'mediumBubble': {
                return React.createElement(MediumBubbleShape, { className: styles[colorClassName] });
            }
            case 'bottomSmallWave': {
                return React.createElement(BottomSmallWaveShape, { className: styles[colorClassName] });
            }
            case 'bottomBigWave': {
                return React.createElement(BottomBigWaveShape, { className: styles[colorClassName] });
            }
            case 'smallCornerBulge': {
                return React.createElement(SmallCornerBulgeShape, { className: styles[colorClassName] });
            }
            case 'curvedCornerBulge': {
                return React.createElement(CurvedCornerBulgeShape, { className: styles[colorClassName] });
            }
            case 'bigCornerBulge': {
                return React.createElement(BigCornerBulgeShape, { className: styles[colorClassName] });
            }
            default:
                return null;
        }
    };
    var SvgShape = function () { return getShape(); };
    return (React.createElement("div", { className: classNames(styles.root, styles[positionClassName], styles[shapeClassName]), id: id },
        React.createElement(SvgShape, null)));
};

export { ShapeComponent as default };
//# sourceMappingURL=ShapeComponent.esm.js.map
